<template>
  <div>
    <NavigationDrawer />
    <v-col class="wrap">
      <Card />
      <div class="important-message">
        <v-icon class="ml-2 mr-2">mdi-information-outline</v-icon>

        Due to price hike from broadcasters, there will be some changes in
        packages from 01 April, 2025. Discounts will be given accordingly.
      </div>
    </v-col>
  </div>
</template>
<script>
import Card from "@/components/Elements/Card.vue";
import NavigationDrawer from "@/views/Dashboard/NavigationDrawer.vue";

export default {
  components: {
    Card,
    NavigationDrawer,
  },
};
</script>

<style scoped>
.wrap {
  padding: 0 200px;
}
.important-message {
  background-color: rgba(255, 137, 131, 0.2);
  padding: 10px;
  border-radius: 5px;
  margin-top: 20px;
  font-size: 14px;
  font-weight: bold;
}
</style>
